import React from "react";
import {formatPrice} from "../VehicleSlide/VehicleInfoSection";
import {VehicleDataDTO} from "../../../../api/generated";

export const VehicleDetailsTitle: React.FC<{ vehicle: VehicleDataDTO }> = ({vehicle}) => {
    return (
        <div className="flex flex-col gap-1">
            <div className="grid grid-cols-[1fr_auto] items-center w-full">
                <h2 className="font-bold text-left line-clamp-2 leading-tight text-[22px]">{vehicle.make ?? "No make"} {vehicle.model ?? "No model"}</h2>
                <div className="flex flex-col items-end justify-end shrink-0">
                    <div className="flex flex-row items-baseline">
                        <p className="text-right whitespace-nowrap font-bold text-2xl">{`£${formatPrice(vehicle)}`}</p>
                        <p className="text-right whitespace-nowrap font-bold text-sm text-gray-700 ml-1 self-end pb-0.5">{vehicle.is_vat_included ? '' : '+VAT'}</p>
                    </div>
                </div>
            </div>
            <p className="text-start font-normal line-clamp-2 text-base">{vehicle.derivative ?? "No derivative"}</p>
        </div>
    );
}
